<template>
  <div class="tw:bg-blue-100 tw:px-4 tw:pt-10 tw:rounded-xl tw:border-blue-700 tw:border tw:relative">
    <div class="tw:flex tw:items-center tw:mb-3">
      <Bulb class="tw:w-3 tw:h-5" />
      <h4 class="tw:font-bold tw:ml-2">{{ $t(title) }}</h4>
    </div>
    <div class="tw:mt-3">
      <ul>
        <li v-for="(item, index) in smartTipsList" :key="index" class="tw:mb-1 tw:list-disc tw:ml-5">
          <span v-if="index > 0" v-html="$t(item)" />
          <span v-else v-html="$t(item, { CommissionRate: commissions })" />
        </li>
      </ul>
    </div>
    <div class="tw:mt-4 tw:flex">
      <div class="tw:pb-4">
        <GhostButton size="medium" @click="toggleChangeCampaignModal">{{
          $t('rc_pause_flow_cpc_change_cta')
        }}</GhostButton>
        <p class="tw:text-xs tw:text-gray-600 tw:font-normal tw:mt-2">{{ $t('rc_pause_flow_cpc_upsell_footnote') }}</p>
      </div>
      <img :src="bellboy" :alt="$t(title)" class="tw:w-[140px] tw:-mt-4" />
    </div>
  </div>
</template>
<script setup>
import { computed } from 'vue'

import Bulb from '@/components/icons/Bulb.svg?component'
import GhostButton from '@/components/base/buttons/GhostButton.vue'

import { useCommissionLevels } from '@/components/rateConnect/queries'
import { useSessionValues } from '@/composables/useSessionValues'

const emit = defineEmits(['toggleChangeCampaignModal'])
const toggleChangeCampaignModal = () => emit('toggleChangeCampaignModal')
const { language } = useSessionValues()
const { eligibleCommissionLevels } = useCommissionLevels()
const props = defineProps({
  id: Number,
})

const bellboy = new URL('/src/assets/img/rate-connect/bellboy.svg', import.meta.url)

const commissions = computed(() => {
  if (!eligibleCommissionLevels.value) return
  return eligibleCommissionLevels.value
    ?.map(item =>
      new Intl.NumberFormat(language.value, {
        style: 'percent',
      }).format(item / 100)
    )
    .join(', ')
})

const title = computed(() => {
  if (props.id === 1 || props.id === 4 || props.id === 6 || props.id === 7 || props.id === 8)
    return 'rc_pause_flow_cpc_upsell_header'
  else return ''
})
const smartTipsList = computed(() => {
  if (props.id === 1) {
    return ['rc_pause_flow_upsell_point_1', 'rc_pause_flow_upsell_point_2', 'rc_pause_flow_cpc_upsell_marketing']
  } else if (props.id === 4 || props.id === 6 || props.id === 7 || props.id === 8) {
    return ['rc_pause_flow_upsell_point_1', 'rc_pause_flow_upsell_point_2', 'rc_pause_flow_upsell_point_3']
  } else {
    return []
  }
})
</script>
